import {
  ArrowLeftIcon,
  ArrowRightIcon,
  DropdownMenu,
  EllipsisVerticalIcon,
  IconButton,
  IconButtonSize,
  IconButtonType,
  PencilIcon,
  PrimaryButton,
  TertiaryButton,
  useDialogState,
} from '@tricor-digital-team/vistra-design-system';
import React, { forwardRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { countries } from '../../../../Utils/Constants';
import { useNavigate } from 'react-router-dom';
import CancelStep from '../CancelStep';
import { resetFormData } from '../../../../Redux/formSlice';
import { removeIndividual, resetIndividual } from '../../../../Redux/individualSlice';
import RemoveStep from '../RemoveStep';
import IndividualModal from '../IndividualDetails/IndividualModal';
import PersonalDetails from '../IndividualDetails/PersonalDetails';

const ReviewDetails = ({ setCurrentStep, customerDetails, setIndividual, isFreezed }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cancelDialog = useDialogState({ visible: false });
  const [requestorDetails, setRequestorDetails] = useState(null);
  const [individualDetails, setIndividualDetails] = useState([]);
  const [selectedIndividual, setSelectedIndividual] = useState([]);

  const [individualIndex, setIndividualIndex] = useState([]);
  const [deleteIndividual, setDeleteIndividual] = useState(null);
  const deleteDialog = useDialogState({ visible: false });
  const dialog = useDialogState({ visible: false });

  const requestor = useSelector((state) => state?.form?.formData);
  const individual = useSelector((state) => state?.individual?.individualDetails);
  useEffect(() => {
    if (customerDetails) {
      setRequestorDetails(customerDetails?.requestorInformation);
      setIndividualDetails(customerDetails?.individuals);
    } else {
      setRequestorDetails(requestor);
      setIndividualDetails(individual);
    }
  }, [customerDetails, requestor, individual]);


  const removeIndividualData = () => {
    dispatch(removeIndividual(deleteIndividual));
  };

  const getName = (item) => {

    if (item?.personalDetails?.middleName) {
      return `${item?.personalDetails?.firstName} ${item?.personalDetails?.middleName} ${item?.personalDetails?.lastName}`
    }
    return `${item?.personalDetails?.firstName} ${item?.personalDetails?.lastName}`

  }
  const IconBtn = forwardRef((props, ref) => {
    return (
      <IconButton
        ref={ref}
        action={props.onClick}
        icon={EllipsisVerticalIcon}
        size={IconButtonSize.Small}
        type={IconButtonType.Regular}
      />
    );
  });

  return (
    <div>
      {!isFreezed && <div className="text-gray-600 text-sm">Check the detail below before you proceed.</div>}
      <div className="flex justify-between items-center w-full mt-6 ">
        <div className="text-black text-2xl font-normal">Customer information</div>
        {!customerDetails && (
          <TertiaryButton
            icon={PencilIcon}
            iconPosition="left"
            label="Edit"
            onClick={() => {
              setCurrentStep(0);
            }}
            size="medium"
          />
        )}
      </div>
      <div className="text-black text-xl font-normal mt-6">Customer information</div>
      <div className="text-black text-base font-bold mt-4">Customer contact</div>
      <div className="flex flex-col md:flex-row gap-6 mt-6">
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Name</div>
          <div className="text-base text-black mb-2">{requestorDetails?.name}</div>
        </div>
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Email </div>
          <div className="text-base text-black mb-2">{requestorDetails?.email}</div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-6 mt-6">
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Job title (optional)</div>
          <div className="text-base text-black mb-2">{requestorDetails?.jobTitle || '-'}</div>
        </div>
        <div className="w-full">

        </div>
      </div>
      {/* <div className="flex flex-col md:flex-row gap-6 mt-6">
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Email Update notification</div>
          <div className="text-base text-black mb-2">
            {requestorDetails?.receiveNotification === true ? 'Yes' : 'No'}
          </div>
        </div>
      </div> */}
      <div className="text-black text-sm font-bold mt-6">Vistra contact person details (optional)</div>
      <div className="flex flex-col md:flex-row gap-6 mt-6">
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Name</div>
          <div className="text-base text-black mb-2">{requestorDetails?.vistraContactName || '-'}</div>
        </div>
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Email </div>
          <div className="text-base text-black mb-2">{requestorDetails?.vistraContactEmail || '-'}</div>
        </div>
      </div>
      <div className="text-black text-xl font-normal mt-12">Customer address</div>
      <div className="w-full mt-6">
        <div className="text-sm text-gray-400 mb-2">Company name</div>
        <div className="text-base text-black mb-2">{requestorDetails?.companyName}</div>
      </div>
      <div className="w-full mt-6">
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Address line</div>
          <div className="text-base text-black mb-2">{requestorDetails?.addressLine1 || '-'}</div>
          <div className="text-base text-black mb-2">{requestorDetails?.addressLine2 || '-'}</div>
          <div className="text-base text-black mb-2">{requestorDetails?.addressLine3 || '-'}</div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-6 mt-6">
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Town</div>
          <div className="text-base text-black mb-2">{requestorDetails?.town || '-'}</div>
        </div>
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">County (optional)</div>
          <div className="text-base text-black mb-2">{requestorDetails?.county || '-'}</div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-6 mt-6">
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Country</div>
          <div className="text-base text-black mb-2">
            {countries.find((country) => country.value === requestorDetails?.country)?.label || '-'}
          </div>
        </div>
        <div className="w-full">
          <div className="text-sm text-gray-400 mb-2">Postcode</div>
          <div className="text-base text-black mb-2">{requestorDetails?.postcode || '-'}</div>
        </div>
      </div>
      <div className="flex justify-between items-center w-full mt-12">
        <div className="text-black text-2xl font-normal">Individual detail</div>
        {!customerDetails && (
          <TertiaryButton
            icon={PencilIcon}
            iconPosition="left"
            label="Edit"
            onClick={() => {
              setCurrentStep(1);
            }}
            size="medium"
          />
        )}
      </div>
      <div class="overflow-x-auto border-t-2 border-gray-100 mt-6">
        <table class="min-w-full border-collapse">
          <thead class="border-b border-gray-100">
            <tr>
              <th
                class={
                  'py-2 text-xs font-medium text-gray-700 text-left text-left' +
                  (customerDetails ? ' w-[404px]' : ' w-[300px]')
                }
              >
                <div class="p-2">Name</div>
              </th>
              <th
                class={
                  'py-2 text-xs font-medium text-gray-700 text-left text-left' +
                  (customerDetails ? ' w-[236px]' : ' w-[198px]')
                }
              >
                <div class="p-2">Email</div>
              </th>

              {(!isFreezed &&
                <th class={
                  'py-2 text-xs font-medium text-gray-700 text-right text-right' +
                  (customerDetails ? ' w-[5px]' : ' w-[5px]')
                }></th>)}


            </tr>
          </thead>
          <tbody>
            {individualDetails.length > 0 &&
              individualDetails.map((item, index) => (
                <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                  <td
                    class={
                      'px-2 py-3 text-sm whitespace-nowrap overflow-hidden text-ellipsis' +
                      ' ' +
                      (customerDetails
                        ? 'text-blue-500 font-medium cursor-pointer max-w-[404px]'
                        : 'text-gray-700 max-w-[292px]')
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      if (customerDetails) {
                        setIndividual(item);
                      }
                    }}
                  >
                    {getName(item)}
                  </td>
                  <td
                    class={
                      'px-2 py-3 text-gray-700 text-sm whitespace-nowrap overflow-hidden text-ellipsis' +
                      (customerDetails ? ' max-w-[198px]' : ' max-w-[146px]')
                    }
                  >
                    {item?.personalDetails?.email}
                  </td>

                  {(!isFreezed && <td class="px-2 py-3 text-gray-900 text-sm flex justify-between w-full items-center">
                    <DropdownMenu
                      positioningClasses="vistra-custom-dropdown w-auto"
                      items={[
                        {
                          type: 'action',
                          title: 'Edit detail',
                          onClick: () => {
                            dialog.show()
                            setIndividualIndex(index);
                            setSelectedIndividual(item);
                          },
                        },
                        {
                          type: 'separator',
                        },
                        {
                          type: 'action',
                          title: 'Remove',
                          onClick: () => {
                            console.log(item.id);
                            setDeleteIndividual(item.id);
                            deleteDialog.show();
                          },
                          destructive: true,
                        },
                      ]}
                      menuButton={IconBtn}
                    />
                  </td>)}

                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {!customerDetails && (
        <div className="flex justify-between items-center mt-8">
          <TertiaryButton
            label="Cancel"
            onClick={() => {
              cancelDialog.show();
            }}
            size="large"
          />
          <div className="flex justify-between gap-6">
            <TertiaryButton
              icon={ArrowLeftIcon}
              iconPosition="left"
              label="Back"
              onClick={() => {
                setCurrentStep(1);
              }}
              size="large"
            />
            <PrimaryButton
              disabled={individualDetails.length === 0}
              icon={ArrowRightIcon}
              iconPosition="right"
              label="Next"
              onClick={() => {
                setCurrentStep(3);
              }}
              size="large"
            />
          </div>
          <CancelStep
            dialog={cancelDialog}
            handleExit={() => {
              dispatch(resetFormData());
              dispatch(resetIndividual());
              cancelDialog.hide();
              navigate('/');
            }}
          />
        </div>
      )}

      <IndividualModal dialog={dialog} individualIndex={individualIndex} selectedIndividual={selectedIndividual} individualDetails={individualDetails} />

      <RemoveStep
        dialog={deleteDialog}
        handleRemove={() => {
          removeIndividualData();
          deleteDialog.hide();
        }}
      />
    </div>
  );
};

export default ReviewDetails;
